import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  onClick?: () => void;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hover = false,
  onClick,
  padding = 'md',
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const baseClasses = `bg-white rounded-lg shadow-md border border-gray-200 ${paddingClasses[padding]} ${className}`;
  const hoverClasses = hover ? 'hover:shadow-lg transition-shadow cursor-pointer' : '';

  if (onClick || hover) {
    const MotionDiv = motion.div as any;
    return (
      <MotionDiv
        className={`${baseClasses} ${hoverClasses}`}
        onClick={onClick}
        whileHover={{ scale: 1.01 }}
        transition={{ duration: 0.2 }}
      >
        {children}
      </MotionDiv>
    );
  }

  return (
    <div className={`${baseClasses} ${hoverClasses}`}>
      {children}
    </div>
  );
};

export default Card;

